import React from 'react';
import { connect } from 'react-redux';
import BCLButton from '../../../common/Buttons/BCLButton';
import { ButtonGroup, Switch, Grid} from "@material-ui/core";
import MonthlySummaryBarChart from './MonthlySummaryBarChart';
import MonthlySummaryPieChart from './MonthlySummaryPieChart';
import { fetchMonthlySummaryData } from '../../../../dataFetchers/monthlySummaryDataFetcher';
import {updateActiveChartType, updateActiveIndex, updateActiveMode, fetchingMonthlySummaryData} from '../../../../actions/monthlySummaryActions';
import BCLLoading from '../../../common/Loading/BCLLoading';
import { USAGE_TYPE, PAGE_EVENT_NAMES, INSIGHTS_PAGES, ARROWS } from '../../../../constants/common';
import { getBECompatibleLocale, getFuelUnit, getBECompatibleFuelType, getToggleUnit } from '../../../../helpers/helper';
import { withLastLocation } from "react-router-last-location";
import { trackEvent } from '../../../../helpers/analyticsHelper';

class MonthlySummaryChart extends React.Component{

    componentDidMount(){
        if(!this.props.monthlySummaryData.activeMode){
            this.props.updateActiveMode(this.props.configData["DASHBOARD.MONTHLY_SUMMARY.MS_LEFT_TOGGLE"])
        }
    }

    constructor(props){
        super(props);
        this.state = {
            noData : false
        }
        this.toggleChartType = this.toggleChartType.bind(this);
        this.fetchBillingCycleData = this.fetchBillingCycleData.bind(this);
        this.toggleModeType = this.toggleModeType.bind(this);
    }

    toggleChartType(type){
        if(this.props.monthlySummaryData.activeChartType === type){
            return;
        } else {
            this.props.updateActiveChartType({
                activeChartType : type
            });
        }
    }

    toggleModeType(){
        let newUsageType = this.props.monthlySummaryData.activeMode === this.props.configData["DASHBOARD.MONTHLY_SUMMARY.MS_LEFT_TOGGLE"] ? this.props.configData["DASHBOARD.MONTHLY_SUMMARY.MS_RIGHT_TOGGLE"] : this.props.configData["DASHBOARD.MONTHLY_SUMMARY.MS_LEFT_TOGGLE"];
        trackEvent(this.props.userId, PAGE_EVENT_NAMES.INSIGHTS, {
            clicked: "usageCostToggle",
            type: newUsageType,
            dashboardView: getBECompatibleFuelType(this.props.configData["fuelType"]),
            shown: INSIGHTS_PAGES.MONTHLY_SUMMARY
        });
        this.props.updateActiveMode(newUsageType);
    }

    fetchBillingCycleData(offset){
        let itemizationDetails = this.props.monthlySummaryData.monthlySummaryDataArray[0].itemizationDetails;
        //call analytics function to save arrow click event
        trackEvent(this.props.userId, PAGE_EVENT_NAMES.INSIGHTS, {
            dashboardView: getBECompatibleFuelType(this.props.configData["fuelType"]),
            shown: INSIGHTS_PAGES.MONTHLY_SUMMARY,
            usageArrowClicked: offset === 1 ? ARROWS.RIGHT : ARROWS.LEFT,
            intervalStart: itemizationDetails.startTs,
            intervalEnd: itemizationDetails.endTs,
        })

        //Take value from monthlySummaryData array if available otherwise fetch from backend
        if(this.props.monthlySummaryData.monthlySummaryDataArray[this.props.monthlySummaryData.monthlySummaryActiveIndex + offset]){
            this.props.fetchingData();
            //Added timeout to clear previous chart data and render the new one.
            setTimeout(()=>{this.props.updateActiveIndex(offset)},100);
        } else {
            this.props.fetchingData();
            let msDataArray = this.props.monthlySummaryData.monthlySummaryDataArray[this.props.monthlySummaryData.monthlySummaryActiveIndex];
            let options = {
                "locale" : getBECompatibleLocale(this.props.configData),
                "measurement-type" : getBECompatibleFuelType(this.props.configData["fuelType"]),
                "date-format": this.props.configData["date_format"]
            }
            if(offset === 1){
                options["bill-start"] = msDataArray.nextBillStart;
                options["bill-end"] = msDataArray.nextBillEnd;
            } else {
                options["bill-start"] = msDataArray.previousBillStart;
                options["bill-end"] = msDataArray.previousBillEnd;
            }
            this.props.fetchMonthlySummaryData(this.props.userId, options, true)
        }
    }

    render(){
        const { monthlySummaryData, configColors } = this.props;
        const activeMode = monthlySummaryData.activeMode;
        const leftToggle = this.props.configData["DASHBOARD.MONTHLY_SUMMARY.MS_LEFT_TOGGLE"];
        const rightToggle = this.props.configData["DASHBOARD.MONTHLY_SUMMARY.MS_RIGHT_TOGGLE"];
        const fuelType = this.props.configData.fuelType.toLowerCase();
        let itemizationData = monthlySummaryData.monthlySummaryDataArray[monthlySummaryData.monthlySummaryActiveIndex];
        return(
            <>
                <div className="insights-arrow arrow-left" disabled={monthlySummaryData.leftArrowDisabled} onClick={() => monthlySummaryData.leftArrowDisabled ? null : this.fetchBillingCycleData(-1)} />
                <div>
                    <div className={"chart-options " + (!itemizationData.itemizationDetails || !itemizationData.itemizationDetails[fuelType] ? "no-data" : "") }>
                        <ButtonGroup size="large" className="ms-chart-button-group">
                            <BCLButton isActive={monthlySummaryData.activeChartType === 'Bar'} btnBackground={`rgba(${configColors['--color_20']}, 0.48)`} btnText="Bar Chart" textColor={`rgb(${configColors['--color_3']})`} borderColor="transparent" btnTextTransform="none" btnWidth="119px" activeColor={`rgb(${configColors['--color_54']})`} onClick={(e) => this.toggleChartType('Bar')} disableRipple={true}/>
                            <BCLButton isActive={monthlySummaryData.activeChartType === 'Pie'} btnBackground={`rgba(${configColors['--color_20']}, 0.48)`} btnText="Pie Chart" textColor={`rgb(${configColors['--color_3']})`} borderColor="transparent" btnTextTransform="none" btnWidth="119px" activeColor={`rgb(${configColors['--color_54']})`} onClick={(e) => this.toggleChartType('Pie')} disableRipple={true}/>
                        </ButtonGroup>
                        {
                            this.props.configData["DASHBOARD.MONTHLY_SUMMARY.TOGGLE_ENABLED"] === "true" ?
                            <div className="ms-unit-toggle-container">
                                <span className={"icon left " + (activeMode === leftToggle ? "active" : "")}>{getToggleUnit(leftToggle, this.props.configData)}</span>
                                <Switch classes={{thumb: "ms-filter-thumb", track: "ms-filter-track", checked: "ms-filter-checked", colorSecondary: "ms-filter-color-secondary"}} checked={activeMode === rightToggle} onChange={(e) => this.toggleModeType()} value={activeMode} />
                                <span className={"icon right " + (activeMode === rightToggle ? "active" : "")}>{getToggleUnit(rightToggle, this.props.configData)}</span>
                            </div>
                            : ''
                        }

                    </div>
                    <div className="chart-container">
                        {monthlySummaryData.fetchingData ? <div className="ms-data-loading"><BCLLoading/></div> : (monthlySummaryData.monthlySummaryDataArray.length !== 0 && monthlySummaryData.activeChartType === "Pie") ?
                        <MonthlySummaryPieChart itemizationData={itemizationData} mode={monthlySummaryData.activeMode} totalText={this.props.translationsData["COMMON.TOTAL_TEXT"]} appliancesList={this.props.appliancesList} fuelType={fuelType}/>
                        : <MonthlySummaryBarChart itemizationData={itemizationData} mode={monthlySummaryData.activeMode} appliancesList={this.props.appliancesList} fuelType={fuelType}/>}
                    </div>
                    {(!itemizationData.itemizationDetails || !itemizationData.itemizationDetails[fuelType]) && !monthlySummaryData.fetchingData ? <div class="no-data-disclaimer">{itemizationData.itemizationDisclaimer}</div> : ''}
                </div>
                <div className="insights-arrow arrow-right" disabled={monthlySummaryData.rightArrowDisabled} onClick={() => monthlySummaryData.rightArrowDisabled ? null : this.fetchBillingCycleData(1)}/>
            </>
        )
    }
}

const mapStateToProps = state => {
    return{
        monthlySummaryData : state.monthlySummaryData,
        userId: state.userIdentityDetails.userId,
        configData : state.configs.data,
        translationsData : state.translationsData.data,
        appliancesList: state.appliances.appliancesList,
        queryParams: state.queryParams
    }
}

const mapDispatchToProps = dispatch => {
    return{
        fetchMonthlySummaryData : (uuid, options, isPrevious) => dispatch(fetchMonthlySummaryData(uuid, options, isPrevious)),
        updateActiveChartType : (payload) => dispatch(updateActiveChartType(payload)),
        updateActiveIndex : (changeOffset) => dispatch(updateActiveIndex(changeOffset)),
        updateActiveMode: (mode) => dispatch(updateActiveMode(mode)),
        fetchingData : () => dispatch(fetchingMonthlySummaryData())
    }
}

export default withLastLocation(connect(mapStateToProps,mapDispatchToProps)(MonthlySummaryChart));
